module.exports = __webpack_public_path__ + "img/square-light-monochrome.ae26963.svg";